
export const setTrailTypes = (state, trailTypes) => {
    state.trailTypes = trailTypes
    state.loading = false
}


export const setCurrentTrailType = (state, trailType) => {
    state.currentTrailType = trailType
    state.loading = false
}

export const setLoading = (state, loading) => {
    state.loading = loading
}
